module.exports = __webpack_public_path__ + "static/img/companypress.232752a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companypress.png
// module id = LEFH
// module chunks = 1